import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    background: theme.palette.common.white,
  },
  '& .RSExperienceCardWrapper': {
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  '& .RVSummarySection': {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 0, 4),
      background: theme.palette.common.white,
      margin: theme.spacing(2, 0),
    },
  },
}));
export default StyledBox;
